import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import DialogsAPI from 'api/DialogsAPI';
import TrackingAPI from 'api/TrackingAPI';
import { GUEST_ROUTES } from 'routes/routes';
import { successAlert } from 'ui-kit/Alert';
import ConfirmationModal from 'ui-kit/ConfirmationModal';


const ResetDialogModal = (props) => {
  const {
    isOpen,
    setIsResetDialogModalOpen,
    setIsRestartGame,
    setIsInfoBlockVisible,
    setBatches,
    setGame,
    setScenario,
    setDialog,
    dialog,
    game,
    alias,
    scenarioId,
    characterName,
    scenario,
    isRestartGame
  } = props;

  const navigate = useNavigate();
  const location = useLocation();

  const analyticsData = {
    scenario: game?.alias,
    config_name: scenario?.name,
    scenario_name: game?.name,
    dialogId: dialog?.id
  };

  const handleClose = () => {
    setIsResetDialogModalOpen(false);
    setIsRestartGame(false);
  };

  const handleSubmit = async () => {
    setIsRestartGame(true);
    setIsInfoBlockVisible(false);

    await DialogsAPI.resetDialog(dialog?.id);
    setIsResetDialogModalOpen(false);

    const currentPath = location.pathname;
    const targetPath = GUEST_ROUTES.ROLEPLAY(game.alias);
    const isAdminPanel = currentPath.includes('scenario-debug');

    if (currentPath !== targetPath && !isAdminPanel) {
      navigate(targetPath);
      setIsRestartGame(false);
      return;
    }

    await DialogsAPI.getDialogByScenarioAlias(
      alias,
      scenarioId,
      characterName,
      isAdminPanel
    ).then(d => {
      if (d !== undefined) {
        setDialog(d?.dialog);
        setScenario(d?.scenario);
        setGame(d?.game);
        setBatches(d?.batches || []);
      }
      setIsRestartGame(false);
    });

    TrackingAPI.trackEvent('dialog_reset', analyticsData);
    successAlert('Dialog has been reset');
  };

  return (
    <ConfirmationModal
      isOpen={isOpen}
      onClose={handleClose}
      title="Dialog reset"
      description="Are you sure you want to reset the dialog?"
      isLoading={isRestartGame}
      onCancel={handleClose}
      onSubmit={handleSubmit}
    />
  );
};

export default ResetDialogModal;